var map = {
	"./american express.svg": "d0e4",
	"./default.svg": "a6ca",
	"./elcart.svg": "9bb5",
	"./kortimilli.svg": "dc4d",
	"./maestro.svg": "d779",
	"./mastercard.svg": "9113",
	"./mir.svg": "6c75",
	"./unionpay.svg": "45ba",
	"./visa.svg": "270b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1d8c";